interface FAQ {
  title: string;
  answer: string;
}

type GroupedFAQs = Record<string, FAQ[]>;
const faqSchema = (groupedFAQs: GroupedFAQs) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    url: "https://www.promotionalproductsnow.au/faq",
    mainEntity: Object.values(groupedFAQs)
      .flat()
      .map((faq) => ({
        "@type": "Question",
        name: faq.title,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
  };
};

export { faqSchema };
